import React, { Fragment } from 'react';
import Table from 'reactstrap/lib/Table';
import { map, mapValues, compact } from 'lodash-es';
import { TcoEntities } from 'client/data/models/cost-to-own';
import { LABELS_MAP } from 'site-modules/cost-to-own/constants/labels-map';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

import './costs-table.scss';

const TAX_CREDIT_LABEL = 'federalTaxCredit';

function transformDataForTable({ total, years }) {
  return compact(
    map(total, (value, key) => {
      if (key === TAX_CREDIT_LABEL) {
        return null;
      }
      return {
        label: LABELS_MAP[key],
        total: formatPriceString(value),
        ...mapValues(years, yearObj => formatPriceString(yearObj[key] || 0)),
      };
    })
  );
}

export function CostsTable({ data = {} }) {
  const tableData = transformDataForTable(data);

  return (
    <Fragment>
      <Table responsive borderless className="costs-table text-gray-darker">
        <caption className="visually-hidden">Ownership Costs: 5-Year Breakdown</caption>
        <thead>
          <tr>
            <th className="col-fixed" />
            <th className="col-padding-left">Year 1</th>
            <th>Year 2</th>
            <th>Year 3</th>
            <th>Year 4</th>
            <th>Year 5</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {compact(
            tableData.map(({ label, total, ...yearsData }) => {
              if (!label) return null;

              return (
                <tr key={`${label}-${total}`}>
                  <th scope="row" className="col-fixed">
                    {label}
                  </th>
                  <td className="col-padding-left">{yearsData['1']}</td>
                  <td>{yearsData['2']}</td>
                  <td>{yearsData['3']}</td>
                  <td>{yearsData['4']}</td>
                  <td>{yearsData['5']}</td>
                  <td className="fw-bold">{total}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </Fragment>
  );
}

CostsTable.propTypes = {
  data: TcoEntities.StyleTco,
};
